import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { getAllCanadianCityOptions } from '../../../utils/canadianCities';

const FilterPanel = ({ filters, onFilterChange, onClearFilters, isOpen, onToggle }) => {
  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    ...getAllCanadianCityOptions()
  ];

  const industryOptions = [
    { value: 'all', label: 'All Industries' },
    { value: 'tech', label: 'Technology' },
    { value: 'construction', label: 'Construction' },
    { value: 'realestate', label: 'Real Estate' },
    { value: 'finance', label: 'Finance' },
    { value: 'healthcare', label: 'Healthcare' }
  ];

  const seniorityOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'senior', label: 'Senior (8-12 years)' },
    { value: 'lead', label: 'Lead (12-15 years)' },
    { value: 'principal', label: 'Principal (15+ years)' },
    { value: 'executive', label: 'Executive (C-Level)' }
  ];

  const managementOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'individual', label: 'Individual Contributor' },
    { value: 'team', label: 'Team Lead (1-5)' },
    { value: 'manager', label: 'Manager (5-15)' },
    { value: 'director', label: 'Director (15+)' }
  ];

  return (
    <>
      <button
        className="lg:hidden fixed bottom-20 right-4 z-50 w-14 h-14 bg-[#5B2DFF] text-white rounded-full shadow-lg flex items-center justify-center"
        onClick={onToggle}
        aria-label="Toggle filters"
      >
        <Icon name="SlidersHorizontal" size={24} />
      </button>
      <div
        className={`fixed lg:relative inset-0 lg:inset-auto z-40 bg-white lg:bg-transparent transform transition-transform duration-250 ${
          isOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'
        }`}
      >
        <div className="h-full lg:h-auto bg-white rounded-2xl border border-[#E5E7EB] p-4 md:p-6 overflow-y-auto">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg md:text-xl font-semibold text-[#111827]">Filters</h3>
            <button
              className="lg:hidden p-2 hover:bg-[#F6F7FB] rounded-lg transition-colors"
              onClick={onToggle}
              aria-label="Close filters"
            >
              <Icon name="X" size={24} />
            </button>
          </div>

          <div className="space-y-4">
            <Input
              label="Search Keywords"
              type="search"
              placeholder="Skills, roles, expertise..."
              value={filters?.keywords}
              onChange={(e) => onFilterChange('keywords', e?.target?.value)}
            />

            <Select
              label="Location"
              options={locationOptions}
              value={filters?.location}
              onChange={(value) => onFilterChange('location', value)}
            />

            <Select
              label="Industry"
              options={industryOptions}
              value={filters?.industry}
              onChange={(value) => onFilterChange('industry', value)}
            />

            <Select
              label="Seniority Level"
              options={seniorityOptions}
              value={filters?.seniority}
              onChange={(value) => onFilterChange('seniority', value)}
            />

            <Select
              label="Management Experience"
              options={managementOptions}
              value={filters?.management}
              onChange={(value) => onFilterChange('management', value)}
            />

            <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Experience Range
              </label>
              <div className="flex items-center gap-3">
                <Input
                  type="number"
                  placeholder="Min"
                  value={filters?.experienceMin}
                  onChange={(e) => onFilterChange('experienceMin', e?.target?.value)}
                  className="flex-1"
                />
                <span className="text-[#6B7280]">to</span>
                <Input
                  type="number"
                  placeholder="Max"
                  value={filters?.experienceMax}
                  onChange={(e) => onFilterChange('experienceMax', e?.target?.value)}
                  className="flex-1"
                />
              </div>
            </div>

            <div className="pt-4 border-t border-[#E5E7EB] space-y-3">
              <Button
                variant="outline"
                fullWidth
                iconName="RotateCcw"
                iconPosition="left"
                onClick={onClearFilters}
              >
                Clear All Filters
              </Button>
              <Button
                variant="default"
                fullWidth
                iconName="Search"
                iconPosition="left"
                onClick={onToggle}
                className="lg:hidden"
              >
                Apply Filters
              </Button>
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={onToggle}
        />
      )}
    </>
  );
};

export default FilterPanel;